import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../../../api/agent";

export interface DealerSettings {
  id: string;
  dmsDealerId: number;
  hasMultipleSite: boolean;
}

export const dealerSettingsApi = createApi({
  reducerPath: "dealerSettingsApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["DealerSettings"],

  endpoints: (build) => ({
    getAllDealerSettings: build.mutation<any, void>({
      query: () => ({
        url: `api/DealerSettings/GetAll`,
        method: "get",
      }),
    }),
    updateDealerSettings: build.mutation<
      any,
      { dmsDealerId: number; hasMultipleSite: boolean }
    >({
      query: ({ dmsDealerId, hasMultipleSite }) => ({
        url: `api/DealerSettings/UpdateSettings`,
        method: "put",
        data: { dmsDealerId, hasMultipleSite },
      }),
      invalidatesTags: ["DealerSettings"],
    }),
  }),
});

export const {
  useUpdateDealerSettingsMutation,
  useGetAllDealerSettingsMutation,
} = dealerSettingsApi;

export const dealerSettingsReducer = dealerSettingsApi.reducer;
